import React, {
  forwardRef, memo, useCallback, useMemo,
} from 'react';
import { func } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import Logger from '../../services/Logger';
import l18n from '../../shared/strings';
import {
  panelsVisibilityShape, getIndicator, flagShow, colorShow, ratingShow,
} from './helpers';
import { isUploadStarted, requiredFields as requiredCustomFieldsSelector } from '../../store/import/selectors';
import DetailsBlock from '../DetailsBlock';
import Marks from '../details/view/AssetMarks';
import { changeField } from '../../store/import/changeField';
import { DIFFERENT_VALUES } from '../../store/import/helpers/groupFields';

const AssetMarks = forwardRef(({ panelsVisibility, toggleVisibility }, ref) => {
  const dispatch = useDispatch();
  const numberOfSelectedFiles = useSelector((state) => state.import.selected.length);
  const color = useSelector((state) => state.import.fields.color);
  const rating = useSelector((state) => state.import.fields.rating);
  const flag = useSelector((state) => state.import.fields.flag);
  const requiredFields = useSelector(requiredCustomFieldsSelector);
  const editPermission = useSelector((state) => state.import.permissions.editAssetMarks);
  const disabled = useSelector(isUploadStarted);
  const error = useSelector((state) => Boolean(state.import.errors.assetMarks));
  const flagError = useSelector((state) => state.import.errors.flag);
  const colorError = useSelector((state) => state.import.errors.color);
  const ratingError = useSelector((state) => state.import.errors.rating);

  const handleChangeColor = useCallback((_, value) => {
    dispatch(changeField({ title: 'color', value }));
    Logger.log('User', 'UploadPanelChangeColor', { value, assets_number: numberOfSelectedFiles });
  }, [dispatch, numberOfSelectedFiles]);

  const handleChangeFlag = useCallback((_, value) => {
    dispatch(changeField({ title: 'flag', value }));
    Logger.log('User', 'UploadPanelChangeFlag', { value, assets_number: numberOfSelectedFiles });
  }, [dispatch, numberOfSelectedFiles]);

  const handleChangeRating = useCallback((_, value) => {
    dispatch(changeField({ title: 'rating', value }));
    Logger.log('User', 'UploadPanelChangeRating', { value, assets_number: numberOfSelectedFiles });
  }, [dispatch, numberOfSelectedFiles]);

  const indicator = useMemo(() => getIndicator('assetMarks', requiredFields), [requiredFields]);

  return (
    <DetailsBlock
      dataQa="assetMarks"
      ref={ref}
      detailsPanelVisibility={panelsVisibility}
      toggleVisibility={toggleVisibility}
      blockName="importAssetMarksVisibility"
      blockTitle={l18n.DETAILS.textAssetMarks}
      indicator={indicator}
      error={error}
      errorHighlight
      openByDefault={error || indicator !== null}
    >
      <Marks
        logEvents={false}
        color={color === DIFFERENT_VALUES ? '' : color}
        changeColor={handleChangeColor}
        rating={rating === DIFFERENT_VALUES ? 0 : rating}
        changeRating={handleChangeRating}
        flag={flag === DIFFERENT_VALUES ? '' : flag}
        changeFlag={handleChangeFlag}
        flagShow={flagShow}
        flagEditable={editPermission}
        colorShow={colorShow}
        colorEditable={editPermission}
        ratingShow={ratingShow}
        ratingEditable={editPermission}
        selectedAssets={['']}
        highlight={[]}
        disabled={disabled}
        flagError={flagError}
        colorError={colorError}
        ratingError={ratingError}
      />
    </DetailsBlock>
  );
});

AssetMarks.propTypes = {
  panelsVisibility: panelsVisibilityShape.isRequired,
  toggleVisibility: func.isRequired,
};

export default memo(AssetMarks);
